import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import MyImage from "../../../../../../../media/images/tunnel.png";
import MyImage2 from "../../../../../../../media/images/home_road.png";
import RemoveDoc from "../../../../../../../media/images/icons/removeDocSvg.svg";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: "1ps xolid gray",
  position: "relative",
}));

export default function PreviewBox() {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "16px",
        border: "1px solid gray",
        padding: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "info.main",
            }}
          >
            فایل های بارگذاری شده:
          </Typography>
        </Button>
      </Box>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
          <Grid item xs={6} sx={{}}>
            <Item>
              <img
                style={{
                  width: "100%",
                }}
                src={MyImage}
                alt=""
              />
              <RemoveDocButton />
            </Item>
          </Grid>
          <Grid item xs={6} sx={{}}>
            <Item>
              <img
                style={{
                  width: "100%",
                }}
                src={MyImage2}
                alt=""
              />
              <RemoveDocButton />
            </Item>
          </Grid>
          {/* <Grid item xs={6} sx={{}}>
            <Item>1</Item>
          </Grid> */}
        </Grid>
      </Box>
    </Box>
  );
}

function RemoveDocButton() {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        width: "22px",
        height: "22px",
        borderRadius: "50%",
      }}
    >
      <img width={"100%"} src={RemoveDoc} alt="" />
    </Box>
  );
}
